import { createSlice } from '@reduxjs/toolkit'

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    watchlist:     null,
    lastObjects:   null,
  },
  reducers: {
    setWatchlist: (state, action) => {
      state.watchlist = action.payload
    },
    setLastObjects: (state, action) => {
      state.lastObjects = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { setWatchlist, setLastObjects } = dashboardSlice.actions

export default dashboardSlice.reducer